import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Lock } from 'lucide-react';
import { Modal, Button } from '@getro/rombo';

// Design ref: Figma node 61019-36628 in file UUTx76vf20bnAdeldVr2G9qU ("Private project modal").

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 520px;
  max-width: 100%;
`;

const IconBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-radius: 9999px;
  background: ${({ theme }) => theme.colors?.neutral?.[50] ?? '#EDF2F7'};
  color: ${({ theme }) => theme.colors?.neutral?.[500] ?? '#67738B'};
`;

const Title = styled.h2`
  margin: 0;
  font-family: 'Silka', sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.text.dark};
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const BodyText = styled.p`
  margin: 0;
  font-family: 'Silka', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.text.main};
`;

const NoProjectAccessModal = ({ isOpen, onClose }) => (
  <Modal isOpen={isOpen} onCancel={onClose}>
    <ModalContent data-testid="no-project-access-modal">
      <IconBadge aria-hidden>
        <Lock size={24} strokeWidth={1.5} />
      </IconBadge>
      <Title id="no-project-access-modal-title">You don&apos;t have access to this project</Title>
      <Body id="no-project-access-modal-description">
        <BodyText>This People Finder project was created by another team member.</BodyText>
        <BodyText>Contact the owner to request access.</BodyText>
      </Body>
      <Button
        onClick={onClose}
        variant="primary"
        aria-describedby="no-project-access-modal-description"
        sx={{ alignSelf: 'flex-start' }}
      >
        Ok
      </Button>
    </ModalContent>
  </Modal>
);

NoProjectAccessModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default NoProjectAccessModal;
